<template>
	<div>
		<h1 class="mw-h1">	{{user.displayName }} </h1>
		<v-card>
		<v-tabs
			v-model="tab"
			background-color="white"
			color="black"
			right 
			show-arrows
			pagination
			:icons-and-text="true"
		>
			<v-tabs-slider></v-tabs-slider>

			<v-tab href="#infoTab">
				User Info <v-icon>mdi-information</v-icon>
			</v-tab>
			<v-tab href="#projectTab">
				Projects <v-icon>mdi-folder-information</v-icon>
			</v-tab>		

			<v-tab-item value="infoTab">
				<v-sheet class="pa-4">
					<v-form
					id="editUserForm"
					class="pa-5" 
					ref="form">
						<v-row>
							<v-col>
								<v-text-field
								v-model="user.firstName"
								label="User Name"
								></v-text-field>	
							</v-col>
							<v-col>
								<v-text-field
								v-model="user.lastName"
								></v-text-field>	
							</v-col>
						</v-row>	
						<v-text-field
						v-model="user.displayName"
						label="Display Name"
						></v-text-field>	
						<v-row>
							<v-col>
								<v-text-field
								v-model="user.email"
								label="Email"
								></v-text-field>	
							</v-col>
							<v-col>
								<v-text-field
								v-model="user.phone"
								label="Phone"
								></v-text-field>	
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-select
									v-model="user.organisation"
									:items="organisations"
									item-value="id"
									item-text="name"
									label="Organisation"
								></v-select>
							</v-col>
							<v-col>
								<v-text-field
								v-model="user.location"
								label="Location"
								></v-text-field>	
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-text-field
								v-model="user.jobTitle"
								label="Job Title"
								></v-text-field>	
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-combobox chips
								v-model="user.roles"
								label="Roles"
								></v-combobox>	
							</v-col>
						</v-row>
						<v-btn
						color="success"
						class="mr-4"
						@click="save"
						>Save
						</v-btn>
					</v-form>
				</v-sheet>
			</v-tab-item>

			<v-tab-item value="projectTab">
				<v-sheet class="pa-4">
					<ListSubpanel name="User Projects" :rows="projects" :headers="headers" class="mt-5" editLink="/edit/projects/"></ListSubpanel>
				</v-sheet>
			</v-tab-item>
		</v-tabs>
		</v-card>
	</div>
</template>

<script>
import Vuex from 'vuex'
import ListSubpanel from "../subpanels/ListSubpanel.vue"
export default {
	name: 'EditUser',
	props: ["user"],
	components: {
		ListSubpanel: ListSubpanel
	},
	data: () => ({
		headers: [
			{
				text: "Name", 
				value: "internalName"
			},
			{
				text: "Live", 
				value: "active"
			},
			{
				value: "linkTo", 
				text: "", 
			}
		]
	}),
	computed: {
		...Vuex.mapState({
			view: state => state.auth.view,
			organisations: state => state[state.auth.view].organisations
		}), 
		projects() {
			const self = this;
			var projects = [];
			projects = self.$store.state[self.view].projects.filter( a => a.users[self.user.id] == self.user.role )
			return projects
		}
	},
	watch: {
		user: {
			deep: true,
			handler: function(   ){
				if( !this.user.firstName || !this.user.lastName ){ return; }
				this.user.displayName = this.user.firstName + " " + this.user.lastName;
			}
		}
	},
	methods: {
		save () {
			var self = this;
			let update = {};
			let exclude = ["id"]
			for( var key in self.user ){
				if( exclude.indexOf( key ) < 0 ){
					update[key] = self.user[key];	
				}
			}
			self.$store.dispatch("updateDoc", {
				doc: "users/" + self.user.id,
				action: "update",
				data: update
			}).then( function(){
				self.$emit("saved");
			}) 
		},
    },
	created: function (){
		if( this.user.role == "client" ){
			this.$store.dispatch( 'fetch', 'organisations' );
		}
		this.$store.dispatch( 'fetchUserProjects', {userId: this.user.id, role: this.user.role });
	},
	destroyed: function (){
	}
};
</script>
